const initialState = null;

const spotLightAds = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_SPOTLIGHT_ADS_SUCCESS':
            return Object.assign({},state,{ ...action.payload });
        case 'GET_SPOTLIGHT_ADS_FAILURE':
            return Object.assign({},state, {});
        default:
            return state;
    }
};

export default spotLightAds;



// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/spotLightAds.js